(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.controller.details-and-figures
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))


(defn details-and-figures
  [{:keys [report-data] :as props}]
  {:current-portfolio   (report-ctl/with-footnote
                         props
                         :current-portfolio-footnotes
                         (get-in report-data [:current-portfolio]))
   :exited-portfolio    (report-ctl/with-footnote
                         props
                         :exited-portfolio-footnotes
                         (get-in report-data [:exited-portfolio]))
   :investment-summary  (report-ctl/with-footnote
                         props
                         :investment-summary-footnotes
                         (:investment-summary report-data))
   :nav-breakdown-ifrs  (report-ctl/with-footnote
                         props
                         :nav-breakdown-ifrs-footnotes
                         (get-in report-data [:nav-breakdown-ifrs]))
   :nav-breakdown-inrev (report-ctl/with-footnote
                         props
                         :nav-breakdown-inrev-footnotes
                         (get-in report-data [:nav-breakdown-inrev]))})
